import React, { createContext, useContext, useState, useCallback, useMemo, useEffect } from "react";
import { TRANSLATIONS } from "@/lib/translations";

const I18nContext = createContext(null);
export const useI18n = () => useContext(I18nContext);

const KEY = "asl_lang";

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem(KEY) || "fr"; } catch { return "fr"; }
  });

  const setLang = useCallback((l) => {
    try { localStorage.setItem(KEY, l); } catch {}
    setLangState(l);
  }, []);

  useEffect(() => {
    // keep the document language in sync (accessibility). Browser auto-translate
    // stays disabled via translate="no" so no DOM corruption / removeChild.
    try { document.documentElement.setAttribute("lang", lang); } catch {}
  }, [lang]);

  const t = useCallback((key, fallback) => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.fr;
    return dict[key] ?? TRANSLATIONS.fr[key] ?? fallback ?? key;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};
